"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dynatrace = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbDynatrace extends baseLibrary_1.BaseLibrary {
    async load() {
        if (window.DYNATRACE_URL && window.DYNATRACE_URL.trim() && !(0, web_ui_framework_1.isWebViewPlatform)()) {
            this.instance = new web_ui_framework_1.Dynatrace(window.DYNATRACE_URL);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('Dynatrace: There is no valid DYNATRACE_URL configured');
        }
    }
}
const Dynatrace = new MbDynatrace();
exports.Dynatrace = Dynatrace;
//# sourceMappingURL=index.js.map